<template>
  <div id="sensor-state-filter">
    <v-btn
      class="btn"
      :outline="btn.outline"
      color="error"
      :dark="btn.dark"
      depressed
      small
      :loading="!customers.length && loading"
      :disabled="customersWithSensorWarningCount === 0"
      @click="toggleFilter"
    >
      <div class="filter-box">
        <span>
          通信欠損
        </span>
        <span class="count mt-1">
          {{ customersWithSensorWarningCount }}件
        </span>
      </div>
    </v-btn>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapState('list', ['customers', 'searchText', 'specialString', 'loading']),
    ...mapGetters('list', ['customersWithSensorWarningCount', 'isFilteredBySensorWarning']),
    btn () {
      return this.isFilteredBySensorWarning
        ? {
          dark: true,
          outline: false
        }
        : {
          dark: false,
          outline: true
        }
    }
  },
  methods: {
    ...mapActions('list', ['search']),
    toggleFilter () {
      const searchText = this.isFilteredBySensorWarning
        ? this.searchText.replaceAll(this.specialString, '').trim()
        : this.specialString + this.searchText

      this.search(searchText)
    }
  }
}
</script>

<style lang="scss" scoped>
#sensor-state-filter {
  .btn {
    border-radius: 10px;
    border-width: 3px;
  }
  position: absolute;
  top: 50%;
  right: -175px;
  transform: translateY(-50%);
  .filter-box {
    display: flex;
    flex-direction: column;
    font-size: 0.9rem;
      font-weight: bold;

    .count {
      font-size: 1rem;
    }
  }
}
</style>
